// extracted by extract-css-chunks-webpack-plugin
module.exports = {"payments":"payments_qd7wM w-full text-white bg-black-lighter border-t-[9px] border-gray-lighter"};